export const certificationsData = [
  {
    title: 'TOEFL ITP - Score 573',
    issuer: 'Englishvit',
    images: [
      '/assets/Certificate/toefl-2025.jpg',
    ],
    highlight: true,
    verifyUrl: 'https://englishvit.com/certificate/status/EV-TO4-03-2025-035039664',
    category: 'Language',
  },
  {
    title: 'Google Advanced Data Analytics Professional Certificate',
    issuer: 'Google & Coursera',
    images: ['/assets/Certificate/Google Advanced Data Analytics.jpg'],
    highlight: true,
    verifyUrl: 'https://coursera.org/share/91e8b75b0d38a97ffe45e8cfd3d62cf3',
    category: 'Data & AI',
  },
  {
    title: 'Database Design & Database Programming with SQL',
    issuer: 'Dicoding | Credential ID: 2007340840-191',
    images: [
      '/assets/Certificate/Sertifikat_RESTU AGIL YULI ARJUN_Database Design & Database Programming with SQL_page-0001_page-0001.jpg',
      '/assets/Certificate/Sertifikat_RESTU AGIL YULI ARJUN_Database Design & Database Programming with SQL_page-0001_page-0002.jpg',
      '/assets/Certificate/Sertifikat_RESTU AGIL YULI ARJUN_Database Design & Database Programming with SQL_page-0001_page-0003.jpg',
    ],
    highlight: true,
    verifyUrl: 'https://digitalent.komdigi.go.id/cek-sertifikat#',
    category: 'Data & AI',
  },
  {
    title: 'Memulai Pemrograman dengan Python',
    issuer: 'Dicoding',
    images: [
      '/assets/Certificate/Memulai Pemrograman dengan Python 1.jpg',
      '/assets/Certificate/Memulai Pemrograman dengan Python 2.jpg',
      '/assets/Certificate/Memulai Pemrograman dengan Python 3.jpg',
    ],
    verifyUrl: 'https://www.dicoding.com/certificates/EYX4KK915PDL',
    category: 'IT & Programming',
  },
  {
    title: 'Belajar Dasar AI',
    issuer: 'Dicoding',
    images: ['/assets/Certificate/Belajar Dasar Ai.jpg'],
    verifyUrl: 'https://www.dicoding.com/certificates/81P25766NPOY',
    category: 'Data & AI',
  },
  {
    title: 'Basic Web Programming',
    issuer: 'ID Camp & Dicoding',
    images: [
      'https://restuagilya.github.io/Portfolio-Restu-Agil-Yuli-Arjun/assets/image/sertif/Pemrograman%20Web.jpg',
    ],
    verifyUrl: '',
    category: 'IT & Programming',
  },
  {
    title: 'Pertukaran Mahasiswa Merdeka (PMM) Batch 3',
    issuer: 'Kemdikbud Republik Indonesia',
    images: [
      '/assets/Certificate/Sertifikat PMM Kemdikbud.jpg',
    ],
    verifyUrl: '',
    category: 'Other',
  },
  {
    title: 'English Speaking 3',
    issuer: 'Jago Bahasa',
    images: [
      'https://restuagilya.github.io/Portfolio-Restu-Agil-Yuli-Arjun/assets/image/sertif/Js3.jpg',
    ],
    verifyUrl: '',
    category: 'Language',
  },
  {
    title: 'English Speaking 2',
    issuer: 'Jago Bahasa',
    images: [
      'https://restuagilya.github.io/Portfolio-Restu-Agil-Yuli-Arjun/assets/image/sertif/Js2.jpg',
    ],
    verifyUrl: '',
    category: 'Language',
  },
  {
    title: 'English Speaking 1',
    issuer: 'Jago Bahasa',
    images: [
      'https://restuagilya.github.io/Portfolio-Restu-Agil-Yuli-Arjun/assets/image/sertif/Js1.jpg',
    ],
    verifyUrl: '',
    category: 'Language',
  },
];

export const certificationStats = {
  certificateCount: `${certificationsData.length}+`,
  toeflScore: '573',
  institutionsCount: '7+',
};
